import { gql } from 'apollo-boost';

export const commonBidModifiersAdjustmentFragment = gql`
    fragment commonBidModifiersAdjustmentFragment on GdBidModifierAdjustment {
        id
        percent

        ... on GdBidModifierRetargetingAdjustment {
            accessible
            retargetingConditionId
        }

        ... on GdBidModifierDemographicsAdjustment {
            age
            gender
        }

        ... on GdBidModifierMobileAdjustment {
            osType
        }

        ... on GdBidModifierInventoryAdjustment {
            inventoryType
        }

        ... on GdBidModifierAdTypeAdjustment {
            adType
        }

        ... on GdBidModifierWeatherAdjustment {
            expression {
                operation
                parameter
                value
            }
        }

        ... on GdBidModifierExpressAdjustment {
            condition {
                operation
                parameter
                value
            }
        }
    }
`;

export const campaignBidModifiersAdjustmentFragment = gql`
    fragment campaignBidModifiersAdjustmentFragment on GdBidModifierAdjustment {
        ... on GdBidModifierABSegmentAdjustment {
            sectionId
            segmentId
        }
    }
`;
